export default __webpack_public_path__ + "static/media/Empty-profile.ad721378.svg";